"use strict";
import { SPECIAL_NAV_ITEMS } from "../consts";

const NavMenuItemBtn = (item, lang, activeHash) => {
  const active = activeHash === item.hash;
  if (SPECIAL_NAV_ITEMS.includes(item)) {
    return `
        <a href="#${item.hash}">
        <div class="nav-cat-title"></div>
        <div id="${item.hash}-btn" class="nav-butt margin-top ${
      active ? "nav-btn-active" : ""
    }">
        ${item[lang]}
        </div>
      </a>`;
  }
  return `
<a href="#${item.hash}" id="${item.hash}-btn" class="nav-butt ${
    active ? "nav-btn-active" : ""
  }">${item[lang]}</a>
`;
};

export default NavMenuItemBtn;
